(() => {
  'use strict';
  if (!window.fetch || !window.HTMLDialogElement?.prototype.showModal) return;
  const cartRoot = window.Shopify?.routes?.root || '/';
  let drawer, content, trigger, busy = false, scrollY = 0, bagScroll = 0;
  let quantities = JSON.parse(document.querySelector('#lnl-cart-quantities')?.textContent || '[]');
  document.addEventListener('cart:refresh', (event) => {
    if (event.detail?.cart?.items) quantities = event.detail.cart.items.map((item) => ({ id: item.variant_id, quantity: item.quantity }));
  });
  const cartUrl = () => {
    const url = new URL(`${cartRoot}cart`, location.origin);
    const theme = new URL(location.href).searchParams.get('preview_theme_id');
    if (theme) url.searchParams.set('preview_theme_id', theme);
    return url.href;
  };
  function create() {
    if (drawer) return;
    drawer = document.createElement('dialog');
    drawer.className = 'lnl-cart-drawer';
    drawer.dataset.cartDrawer = '';
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-labelledby', 'drawer-cart-title');
    drawer.innerHTML = '<button type="button" class="lnl-cart-drawer__close" aria-label="Close">×</button><div class="lnl-cart-drawer__content"></div>';
    content = drawer.querySelector('.lnl-cart-drawer__content');
    drawer.querySelector('button').addEventListener('click', () => drawer.close());
    content.addEventListener('scroll', (event) => {
      if (event.target.classList?.contains('cart-page__form')) bagScroll = event.target.scrollTop;
    }, true);
    drawer.addEventListener('click', (event) => {
      const r = drawer.getBoundingClientRect();
      if (event.target === drawer && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) drawer.close();
    });
    drawer.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;
      const controls = [...drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex="0"]')]
        .filter((element) => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
        event.preventDefault(); last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first?.focus();
      }
    });
    drawer.addEventListener('close', () => {
      document.documentElement.classList.remove('lnl-cart-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo({ top: scrollY, behavior: 'instant' });
      trigger?.focus({ preventScroll: true });
    });
    document.body.append(drawer);
  }
  function prepare() {
    const heading = content.querySelector('.cart-page__title');
    if (!heading) throw new Error('Missing cart section heading');
    heading.id = 'drawer-cart-title';
    heading.tabIndex = -1;
    // Native modal dialog supplies focus trapping and inert background, including preview UI.
    // One scrolling bag (items, Double Trouble card, subtotal) with Checkout + express wallets pinned at the bottom.
    const form = content.querySelector('.cart-page__form');
    const express = content.querySelector('.lnl-cro-express');
    const checkout = form?.querySelector('.cart-page__checkout-btn');
    if (form && checkout) {
      let footer = form.querySelector(':scope > .lnl-cart-drawer__footer');
      if (!footer) {
        footer = document.createElement('div');
        footer.className = 'lnl-cart-drawer__footer';
        form.append(footer);
      }
      // Reassurance sits right above Checkout, pinned, so it is never half-hidden under the footer.
      const trust = form.querySelector('.cart-page__trust');
      if (trust) footer.append(trust);
      footer.append(checkout);
      if (express) {
        // Shopify's supported opt-out: keep wallets in one row instead of a tall stack on phones.
        express.classList.add('additional-checkout-buttons--horizontal');
        footer.append(express);
      }
    }
    const images = content.querySelectorAll('.cart-item img');
    images.forEach((image) => { image.loading = 'eager'; });
    window.Shopify?.PaymentButton?.init();
    return heading;
  }

  function esc(text) { const d = document.createElement('div'); d.textContent = text || ''; return d.innerHTML; }
  function openShell() {
    // Instant feedback: slide the bag up with the product being added; the real cart replaces it when Shopify answers.
    const title = (document.querySelector('.lnl-pdp__title, h1')?.textContent || '').trim().replace(/\s+/g, ' ');
    const amount = document.querySelector('meta[property="og:price:amount"]')?.content;
    const price = amount ? `$${amount}` : '';
    // Use the product photo already on screen (cached), so the sheet shows it instantly.
    const lead = document.querySelector('[data-lnl-gallery-slide] img');
    const image = lead && lead.complete && lead.naturalWidth ? lead.currentSrc || lead.src : '';
    content.setAttribute('aria-busy', 'true');
    content.innerHTML = `<div class="shopify-section section-cart lnl-cart-pending"><section class="cart-page"><div class="container">
      <header class="cart-page__header"><h2 class="cart-page__title" id="drawer-cart-title" tabindex="-1">Your bag.</h2></header>
      <div class="cart-page__form"><div class="cart-page__items"><div class="cart-item">
        <div class="cart-item__media">${image ? `<img src="${esc(image)}" alt="" width="76" height="76" style="width:76px;height:76px;object-fit:cover">` : ''}</div>
        <div class="cart-item__info"><p class="cart-item__title">${esc(title)}</p><p class="lnl-cart-pending__price">${esc(price)}</p>
        <p class="lnl-cart-pending__note" role="status">Adding to your bag…</p></div>
      </div></div></div></div></section></div>`;
    if (!drawer.open) {
      scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.documentElement.classList.add('lnl-cart-open');
      drawer.showModal();
    }
    content.querySelector('.cart-page__title')?.focus({ preventScroll: true });
  }
  function closeShell() { if (drawer?.open) drawer.close(); }
  window.LNLCartDrawer = {
    async add(form, submitter) {
      if (busy) return;
      create();
      busy = true;
      bagScroll = 0;
      trigger = submitter || form.querySelector('[name="add"]');
      const buttons = [form.querySelector('[name="add"]'), document.querySelector('[data-lnl-mobile-cart] button[type="submit"]')].filter(Boolean);
      const labels = buttons.map((button) => button.innerHTML);
      const body = new FormData(form);
      const variant = Number(body.get('id'));
      const previous = quantities.filter((item) => Number(item.id) === variant).reduce((sum, item) => sum + item.quantity, 0);
      body.set('sections', 'main-cart');
      body.set('sections_url', `${cartRoot}cart`);
      buttons.forEach((button) => { button.disabled = true; button.textContent = 'Adding…'; });
      form.setAttribute('aria-busy', 'true');
      try { sessionStorage.setItem('lnl_cart_intent', '1'); } catch (_) {}
      try { openShell(); } catch (_) { /* fall back to opening after the response */ }
      let added = false;
      try {
        await window.LNLWaitForCartTracking?.();
        const response = await fetch(`${cartRoot}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body });
        if (!response.ok) {
          if (response.status >= 500) throw new Error('Unconfirmed cart add');
          // Shopify rejected the add. Native submission retains Shopify's normal error handling.
          closeShell();
          HTMLFormElement.prototype.submit.call(form);
          return;
        }
        added = true;
        const payload = await response.json();
        const html = payload.sections?.['main-cart'];
        if (!html) throw new Error('Missing rendered cart');
        const section = new DOMParser().parseFromString(html, 'text/html').querySelector('.section-cart');
        if (!section) throw new Error('Missing rendered cart section');
        content.replaceChildren(section);
        const heading = prepare();
        quantities = [...section.querySelectorAll('.cart-item__qty-input')].map((input) => ({ id: Number(input.dataset.key.split(':')[0]), quantity: Number(input.value) }));
        section.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
        const count = [...section.querySelectorAll('.cart-item__qty-input')].reduce((sum, input) => sum + Number(input.value), 0);
        const badge = document.querySelector('#cart-count');
        if (badge) badge.textContent = count;
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: payload }));
        if (!drawer.open) {
          scrollY = window.scrollY;
          document.body.style.position = 'fixed';
          document.body.style.top = `-${scrollY}px`;
          document.body.style.width = '100%';
        }
        content.removeAttribute('aria-busy');
        if (!drawer.open) {
          document.documentElement.classList.add('lnl-cart-open');
          drawer.showModal();
        }
        heading.focus({ preventScroll: true });
      } catch (_) {
        // Reconcile an uncertain network failure before deciding whether a native retry is safe.
        if (!added) {
          try {
            const response = await fetch(`${cartRoot}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
            if (response.ok) {
              const cart = await response.json();
              const current = cart.items.filter((item) => Number(item.variant_id) === variant).reduce((sum, item) => sum + item.quantity, 0);
              if (current === previous) {
                closeShell();
                HTMLFormElement.prototype.submit.call(form);
                return;
              }
            }
          } catch (_) { /* An unreachable cart is not proof that the add failed. */ }
        }
        // An accepted or unconfirmed add must never be replayed: avoid two paid units.
        location.assign(cartUrl());
      } finally {
        busy = false;
        buttons.forEach((button, index) => { button.disabled = false; button.innerHTML = labels[index]; });
        form.removeAttribute('aria-busy');
      }
    },
    refresh() {
      if (!drawer?.open) return;
      const heading = prepare();
      const bag = content.querySelector('.cart-page__form');
      if (bag) bag.scrollTop = bagScroll;
      if (!content.contains(document.activeElement)) heading.focus({ preventScroll: true });
    }
  };
})();
